import i18n from '../../i18n/i18n';
import { tr } from '../../i18n/i18n';
import {
  IAttendanceDeleteRequest,
  IAttendanceDeleteResponse,
} from '../../interface/attendanceModel';
import { deleteAttendance as deleteAttendanceService } from '../../services/attendance';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import {
  IPostAttendanceResponse,
  IPostAttendancePayload,
  IAttendanceError,
  ICheckoutResponseBody,
  ICheckoutRequestBody,
} from '../../interface/attendanceModel';
import {

  ChekoutAttendance,
  postAttendance as postAttendanceService,
} from '../../services/attendance';

export const postAttendance = createAsyncThunk<
  IPostAttendanceResponse,
  IPostAttendancePayload,
  { rejectValue: IAttendanceError }
>('attendance/postAttendanceCheckin', async (body, { rejectWithValue }) => {
  try {
    const response = await postAttendanceService(body);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IAttendanceError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const postAttendanceCheckout = createAsyncThunk<
  ICheckoutResponseBody,
  ICheckoutRequestBody,
  { rejectValue: IAttendanceError }
>('attendance/postAttendanceCheckout', async (body, { rejectWithValue }) => {
  try {
    const response = await ChekoutAttendance(body);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IAttendanceError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const deleteAttendance = createAsyncThunk<
  IAttendanceDeleteResponse,
  IAttendanceDeleteRequest,
  { rejectValue: IAttendanceError }
>('attendance/deleteAttendance', async (body, { rejectWithValue }) => {
  try {
    const response = await deleteAttendanceService(body);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<IAttendanceError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const attendanceAction = {
  postAttendance,
  postAttendanceCheckout,
  deleteAttendance,
};
